import Swiper from 'swiper'
import { Navigation, Autoplay, FreeMode } from 'swiper/modules'

import 'swiper/css'
import "swiper/css/navigation"
import 'swiper/css/autoplay'

let config

export const initSwiper = () => {
  const sliders = document.querySelectorAll('[data-swiper]')

  if (!sliders.length) return

  sliders.forEach((slider) => {
    const type = slider.getAttribute('data-swiper')
    let autoSlideChange = false

    switch (type) {
      case 'slider-large':
        config = {
          loop: true,
          speed: 750,
          slidesPerView: 1,
					spaceBetween: 12,
					initialSlide: 1,
					grabCursor: true,
					breakpoints: {
						651: {
							spaceBetween: 24,
						}
					}
        }
        break
      case 'slider-small':
        config = {
          loop: true,
          speed: 750,
          slidesPerView: 2,
					spaceBetween: 12,
					initialSlide: 1,
					grabCursor: true,
					breakpoints: {
						651: {
							spaceBetween: 24,
							slidesPerView: 4,
						}
					}
        }
        break
      default:
        break
    }

    const swiper = new Swiper(slider, { ...config })

  })
}

export default () => { }